__webpack_require__.p = "http://localhost:8888/killick-tire/wp-content/themes/jac/dist/";